import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useCreateLegalMatterStageMutation, useLegalMatterStageAutocompleteQuery } from '../../../../../queries';
import { SearchIcon } from '../../../svgs/icons/SearchIcon';
import { TextInput } from '../../../TextInput';
import { styleSheet } from '../../SearchComponent/styles';

export const MatterStageSearch = ({
	onSelectStage,
	canAdd = true,
	onCreateStage,
	initialSearchFragment,
	className,
	dropdownClassName,
	onClear,
}: {
	onSelectStage: (stage: Api.ILegalMatterStage) => void;
	canAdd?: boolean;
	onCreateStage?: (stage: Api.ILegalMatterStage) => void;
	initialSearchFragment?: string;
	className?: string;
	dropdownClassName?: string;
	onClear?: () => void;
}) => {
	const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
	const [searchFragment, setSearchFragment] = React.useState<string>(initialSearchFragment ?? '');
	const addStageMutation = useCreateLegalMatterStageMutation({
		onSuccess: (result: Api.ILegalMatterStage) => {
			setSearchFragment(result.name);
			onCreateStage?.(result);
			setIsDropdownOpen(false);
		},
	});

	const selectStage = (stage: Api.ILegalMatterStage) => {
		setSearchFragment(stage.name);
		setIsDropdownOpen(false);
		onSelectStage(stage);
	};

	const updateSearchFragment = (newValue: string) => {
		setSearchFragment(newValue);

		if (newValue) {
			setIsDropdownOpen(true);
		} else {
			setIsDropdownOpen(false);
			onClear?.();
		}
	};

	const createNewStage = () => {
		const stage: Api.ILegalMatterStage = {
			name: searchFragment,
		};
		addStageMutation.mutate({
			stage,
		});
	};

	const stageAutocompleteQuery = useLegalMatterStageAutocompleteQuery({
		enabled: !!searchFragment,
		pageSize: 25,
		fragment: searchFragment,
	});

	const stages = stageAutocompleteQuery.data?.pages.map(page => page.values).flat() ?? [];

	return (
		<div className={`${css(styleSheet.searchInputWrap)} ${className || ''}`}>
			<TextInput
				className={css(isDropdownOpen ? styleSheet.popoverOpen : null)}
				inputId='matter-modal-edit-stage'
				onChange={e => updateSearchFragment(e.target.value)}
				type='text'
				value={searchFragment}
				placeholder='Search'
				leftAccessory={<SearchIcon className={css(styleSheet.searchIcon)} />}
			/>

			{isDropdownOpen ? (
				<div className={`${css(styleSheet.dropdown)} ${dropdownClassName || ''}`}>
					{stages.length === 0 && !stageAutocompleteQuery.isPending ? <i>No matches found</i> : null}

					{stages.map(stage => {
						return (
							<button onClick={() => selectStage(stage)} key={`stage-${stage.id}`}>
								{stage.name}
							</button>
						);
					})}

					{canAdd && !!searchFragment ? (
						<button className={css(styleSheet.addNewButton)} onClick={createNewStage}>
							<span>+ Add &quot;{searchFragment}&quot;</span>
						</button>
					) : null}
				</div>
			) : null}
		</div>
	);
};
